/**
 * ⚒️ TIER 4 BUILDINGS - Metallurgy & Wealth
 * 
 * Unlocked by: Metallurgy, Deep Mining, Prospecting, Blacksmithing, etc.
 * Cost multiplier: 15.6x | Prod multiplier: 4.1x
 * Costs: 750-1,500 | Production: 1.6-2.5/s
 * Target ROI: ~3 minutes
 */

export const TIER_04_BUILDINGS = {
  mine: {
    id: 'mine',
    name: 'Iron Mine',
    icon: '⛰️',
    tier: 4,
    description: 'Extracts iron from deep shafts',
    flavor: 'Iron is the backbone of progress.',
    baseCost: { wood: 500, stone: 400, gold: 125 },
    baseProduction: { iron: 1.2 },
    unlockCondition: { tech: 'metallurgy' },
  },
  
  goldMine: {
    id: 'goldMine',
    name: 'Gold Mine',
    icon: '💰',
    tier: 4,
    description: 'Extracts precious gold',
    flavor: 'Where there is gold, there is power.',
    baseCost: { stone: 625, iron: 310 },
    baseProduction: { gold: 2.0 },
    unlockCondition: { tech: 'prospecting' },
  },

  gemMine: {
    id: 'gemMine',
    name: 'Gem Mine',
    icon: '💎',
    tier: 4,
    description: 'Unearths precious gemstones',
    flavor: 'Beauty lies beneath the surface.',
    baseCost: { stone: 940, iron: 375, gold: 310 },
    baseProduction: { gems: 0.4 },
    unlockCondition: { tech: 'gemcutting' },
  },

  smelter: {
    id: 'smelter',
    name: 'Smelter',
    icon: '🔥',
    tier: 4,
    description: 'Processes raw iron ore',
    flavor: 'Fire purifies and strengthens.',
    baseCost: { stone: 625, iron: 250 },
    baseProduction: { iron: 1.6 },
    unlockCondition: { tech: 'smelting' },
  },

  forge: {
    id: 'forge',
    name: 'Forge',
    icon: '⚒️',
    tier: 4,
    description: 'Crafts iron into tools',
    flavor: 'The ring of hammer on anvil.',
    baseCost: { stone: 750, iron: 375 },
    baseProduction: { tools: 0.8 },
    unlockCondition: { tech: 'blacksmithing' },
  },

  market: {
    id: 'market',
    name: 'Market',
    icon: '🏪',
    tier: 4,
    description: 'Trades goods for gold',
    flavor: 'Where supply meets demand.',
    baseCost: { wood: 625, stone: 500, gold: 190 },
    baseProduction: { gold: 2.5 },
    unlockCondition: { tech: 'currency' },
  },

  barracks: {
    id: 'barracks',
    name: 'Barracks',
    icon: '🛡️',
    tier: 4,
    description: 'Trains soldiers for battle',
    flavor: 'Where warriors are forged.',
    baseCost: { wood: 625, stone: 625, iron: 250 },
    baseProduction: { population: 0.8 },
    unlockCondition: { tech: 'military_training' },
  },

  hospital: {
    id: 'hospital',
    name: 'Hospital',
    icon: '🏥',
    tier: 4,
    description: 'Heals the sick and wounded',
    flavor: 'A sanctuary of healing.',
    baseCost: { wood: 500, stone: 625, gold: 310 },
    baseProduction: { population: 1.2 },
    unlockCondition: { tech: 'medicine' },
  },
};

export default TIER_04_BUILDINGS;
